/* BASAL 2.0 — paquetes, barra fija, Releasit, galería, reseñas y menú. JavaScript nativo, sin librerías. */
(function () {
  'use strict';
  var d = document;
  function publish(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }
  function $all(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }

  /* Menú móvil */
  $all('[data-b2-menu]').forEach(function (menu) {
    var header = menu.closest('[data-b2-header]');
    menu.addEventListener('toggle', function () {
      if (menu.open && header) d.documentElement.style.setProperty('--b2-header-bottom', header.getBoundingClientRect().bottom + 'px');
    });
    menu.addEventListener('keydown', function (e) { if (e.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
    $all('a', menu).forEach(function (a) { a.addEventListener('click', function () { menu.open = false; }); });
  });

  /* Clics a WhatsApp (evento propio para medir) */
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="wa.me/"]');
    if (a) publish('b2_whatsapp_click', { location: a.getAttribute('data-b2-loc') || location.pathname });
  });

  /* Galería sin carrusel */
  $all('[data-b2-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-b2-main]');
    var thumbs = $all('[data-b2-thumb]', g);
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (!main) return;
        main.srcset = t.getAttribute('data-srcset') || '';
        main.src = t.getAttribute('data-src');
        main.alt = t.getAttribute('data-alt') || main.alt;
        thumbs.forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
      });
    });
  });

  /* Selector de paquetes */
  var form = d.querySelector('[data-b2-form]');
  var stickyEl = d.querySelector('[data-b2-sticky]');
  function syncPack() {
    if (!form) return;
    var r = form.querySelector('input[data-b2-pack]:checked');
    if (!r) return;
    var save = r.getAttribute('data-save');
    $all('[data-b2-total]').forEach(function (n) { n.textContent = r.getAttribute('data-total'); });
    $all('[data-b2-sel-label]').forEach(function (n) { n.textContent = r.getAttribute('data-label'); });
    $all('[data-b2-save-line]').forEach(function (n) { n.textContent = save ? 'Ahorrás ' + save : ''; n.hidden = !save; });
  }
  if (form) {
    form.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute('data-b2-pack')) {
        syncPack();
        publish('b2_pack_select', { pack: e.target.getAttribute('data-units'), product: form.getAttribute('data-product') });
      }
    });
    window.addEventListener('pageshow', syncPack);
    syncPack();
  }

  /* Releasit inserta su botón dentro del formulario (App Embed). Si a los 6 s no apareció,
     se muestra el respaldo por WhatsApp. Nunca se envía al /checkout. */
  var zone = d.querySelector('[data-b2-codzone]');
  function releasitButton() {
    if (!form) return null;
    return form.querySelector('._rsi-buy-now-button-app-block-hook button, button[class*="rsi_"], [class*="_rsi-buy-now"] button');
  }
  if (zone) {
    var t0 = Date.now();
    (function wait() {
      if (releasitButton()) { zone.classList.remove('is-fallback'); d.documentElement.classList.add('b2-rsi-ready'); return; }
      if (Date.now() - t0 > 6000) { zone.classList.add('is-fallback'); publish('b2_releasit_missing', {}); return; }
      setTimeout(wait, 300);
    })();
  }

  /* Botones secundarios (barra fija y CTA final): enlaces /rsi-btn-hook, el gancho documentado de Releasit.
     Si Releasit no atendió el clic, se usa su botón del formulario; si la app no cargó, se vuelve al selector. */
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-b2-buy]');
    if (!a) return;
    publish('b2_buy_click', { location: a.getAttribute('data-b2-loc') || '' });
    if (e.defaultPrevented) return;
    e.preventDefault();
    var btn = releasitButton();
    if (btn) { btn.click(); return; }
    var anchor = d.getElementById('b2-buy');
    if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  $all('[data-b2-goto-buy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var anchor = d.getElementById('b2-buy');
      if (!anchor) return;
      anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var f = anchor.querySelector('input[data-b2-pack]:checked');
      if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 450);
    });
  });

  /* Barra fija: aparece después de pasar el selector y se oculta cuando el CTA final está en pantalla. */
  if (stickyEl && 'IntersectionObserver' in window) {
    d.body.classList.add('b2-hide-rsi-float');
    var startEl = d.querySelector('[data-b2-sticky-start]');
    var hideEls = $all('[data-b2-sticky-hide]');
    var state = { past: false, visible: new Map() };
    var render = function () {
      var anyVisible = false;
      state.visible.forEach(function (v) { if (v) anyVisible = true; });
      var on = state.past && !anyVisible;
      stickyEl.classList.toggle('is-on', on);
      stickyEl.setAttribute('aria-hidden', on ? 'false' : 'true');
      if ('inert' in stickyEl) stickyEl.inert = !on;
      d.body.classList.toggle('b2-has-sticky', on);
      d.documentElement.style.setProperty('--b2-sticky-h', on ? stickyEl.offsetHeight + 'px' : '0px');
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        state.visible.set(en.target, en.isIntersecting);
        if (en.target === startEl) state.past = !en.isIntersecting && en.boundingClientRect.top < 0;
      });
      render();
    });
    hideEls.forEach(function (w) { io.observe(w); });
    render();
  }

  /* Reseñas: abrir formulario, validar y evitar repetidas desde el mismo navegador. */
  $all('[data-b2-review-open]').forEach(function (btn) {
    var target = d.getElementById(btn.getAttribute('aria-controls'));
    if (!target) return;
    btn.addEventListener('click', function () {
      var open = target.hidden;
      target.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var first = target.querySelector('input[type=radio]'); if (first) first.focus(); }
    });
  });
  $all('[data-b2-review-form]').forEach(function (f) {
    var key = 'b2-review-' + f.getAttribute('data-product');
    var msg = f.querySelector('[data-b2-review-msg]');
    var done = false;
    try { done = localStorage.getItem(key) === '1'; } catch (e) {}
    if (done && msg && !f.querySelector('.b2-msg--ok')) {
      msg.className = 'b2-msg b2-msg--ok';
      msg.textContent = 'Ya enviaste una reseña de este producto desde este dispositivo. ¡Gracias!';
    }
    f.addEventListener('submit', function (e) {
      var rating = f.querySelector('input[data-b2-rating]:checked');
      var text = f.querySelector('[data-b2-review-text]');
      var hp = f.querySelector('[data-b2-hp]');
      var err = '';
      if (hp && hp.value) { e.preventDefault(); return; }
      if (!rating) err = 'Elegí de 1 a 5 estrellas.';
      else if (!text || text.value.trim().length < 10) err = 'Contanos un poco más: el comentario necesita al menos 10 caracteres.';
      if (err) { e.preventDefault(); if (msg) { msg.className = 'b2-msg b2-msg--err'; msg.textContent = err; } return; }
      var body = f.querySelector('[data-b2-body]');
      var pub = f.querySelector('[data-b2-public-name]');
      if (body) body.value = 'RESEÑA - ' + f.getAttribute('data-product-title') + ' | ' + rating.value + '/5 | ' + (pub ? pub.value : '') + ' | ' + text.value.trim();
      try { localStorage.setItem(key, '1'); } catch (e2) {}
      publish('b2_review_submit', { product: f.getAttribute('data-product') });
    });
  });
})();